import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';

const AuthenticatedRoute = ({ component: C, props: cProps, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) => {
                return (cProps.isAuthenticated)
                    ? <C {...props} {...cProps} />
                    : (
                        <Redirect to={{
                            pathname: '/',
                            state: { from: props.location },
                        }}
                        />
                    );
            }}
        />
    );
};

AuthenticatedRoute.defaultProps = {
    props: {},
    location: {},
};

AuthenticatedRoute.propTypes = {
    component: PropTypes.func.isRequired,
    props: PropTypes.object,
    location: PropTypes.shape({
        pathname: PropTypes.string,
        search: PropTypes.string,
    }),
};

export default AuthenticatedRoute;
